function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "icon-move");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-move",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "\\uE82E",
  fill: "#4A4A4A",
  fillRule: "nonzero",
  points: "16 9.32 22.68 16 16 22.68 14.82 21.5 19.48 16.82 9.32 16.82 9.32 15.18 19.48 15.18 14.82 10.5"
}));

function SvgIconMoveIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "201b0dcb205af6e536c794ef71647f4c.svg";
export { SvgIconMoveIndicator as ReactComponent };